{
  "title": "Best offers for you",
  "data": [
    {
        "id": "1052020",
        "imageId": "rng/md/carousel/production/3ab75a3a32fcdb221ac67d3cb5e493f6",
        "action": {
            "link": "https://www.swiggy.com/collections/88750?collection_id=88750&tags=layout_ux4&type=rcv2",
            "text": "Delivery under 30 mins",
            "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
            "altText": "Delivery under 30 mins",
            "altTextCta": "order now"
        },
        "entityId": "88750",
        "frequencyCapping": {}
    },
    {
        "id": "1486946",
        "imageId": "rng/md/carousel/production/319f9a16134523b51cab616b2d56dc42",
        "action": {
            "link": "swiggy://webviewV2?pushScreen=true&webview_url=https://webviews.swiggy.com/orange-card/application_start/",
            "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
            "altText": "cbcc",
            "altTextCta": "order now"
        },
        "entityId": "swiggy://webviewV2?pushScreen=true&webview_url=https://webviews.swiggy.com/orange-card/application_start/",
        "frequencyCapping": {}
    },
    {
        "id": "1170780",
        "imageId": "rng/md/carousel/production/7f77d34fccef6a22db009b5281f22ae2",
        "action": {
            "link": "https://www.swiggy.com/collections/92288?collection_id=92288&tags=layout_ux4%2CDISCOUNTING_COUPON_PARTY&type=rcv2",
            "text": "Holi",
            "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
            "altText": "NO UPPER LIMIT",
            "altTextCta": "Order Now"
        },
        "entityId": "92288",
        "frequencyCapping": {}
    }
]
}
